
import 'countries-list';

export default {
  inject: ['$validator'],
  data() {
    return {
      InternationalPhoneVal: '',
      countries: {},
      countrySelectormodel: ''
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          areaCode: '44',
          lineNumber: ''
        }
      }
    },
    name: {
      type: String,
      default: "InternationalPhone"
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    componentError: {
      type: String,
      required: false
    }
  },
  computed: {
    inputVal: {
      get: function () {
        return this.value
      },

      set: function (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    countrySelectormodel(newVal) {
      this.inputVal.areaCode = newVal.phone;
    }

  },
  mounted() {
    const {countries} = require('countries-list');
    this.setDefaultContry(countries);
  },
  methods: {

    // Sets the selected country on page load
    setDefaultContry(countries) {

      // convert the counties object into a sensible payload (array of objects) so that it can be sorted alphabetically.
      let co = Object.keys(countries).map(function (key) {
        countries[key].code = key;
        return (countries[key]);
      });

      // sort the countires by name, alphabetically
      this.countries = co.sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

      // if a value hasn't been set, lets select UK as default
      if (!this.value.areaCode) {
        this.value.areaCode = '44';
      }

      // some provinces share phone country codes, including the UK, if it's a 44 number, let's select United Kingdom by default
      // otherwise just select the first country found that's a match.
      let possibleCountries = this.countries.filter(country => country.phone == this.value.areaCode);
      let gb = possibleCountries.filter(country => country.code == 'GB');
      this.countrySelectormodel = gb.length ? gb[0] : possibleCountries.length ? possibleCountries[0] : '';
    },

    onFocus() {
      this.$emit('onFocus');
    },

    onBlur() {
      this.$emit('onBlur');
    },
  }
}

